import React, { useState } from 'react'
import {
    Col,
    Row,
    Form
} from 'react-bootstrap'
import MaskedInput from 'react-input-mask'
import { useForm, Controller } from 'react-hook-form'

import { faSave, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import * as libValidate from '@lib/validate'

const Contact = (props) => {

    const {
        control,
        formState: { errors },
        handleSubmit,
        register,
        reset,
        setValue,
    } = useForm({ mode: 'onChange' })

    const [inputDisable, setInputDisable] = useState(true)
    const [inputMask, setInputMask] = useState('')
    const [inputValidate, setInputValidate] = useState('')

    const onApplyMask = (value) => {
        const e = document.getElementById('type_contact')
        const mask = e.options[e.selectedIndex].hasAttribute('data-mask')
        setInputMask((mask) ? e.options[e.selectedIndex].getAttribute('data-mask') : '')

        const validate = e.options[e.selectedIndex].hasAttribute('data-validate')
        setInputValidate(validate ? e.options[e.selectedIndex].getAttribute('data-validate') : '')
    }

    const onSubmit = data => {
        console.log(data)
        console.log(inputValidate)
        reset()
    }


    return (

        <>

            <Form onSubmit={handleSubmit(onSubmit)}>

                <Row className='mb-3 mt-4'>
                    <Col lg={3}>
                        <Form.Group>
                            <Form.Label htmlFor='type_contact'>Tipo de Contato</Form.Label>
                            <Form.Select
                                aria-label='Selecione o tipo de contato'
                                id='type_contact'
                                {...register('type_contact', {
                                    required: { value: true, message: 'Campo obrigatório' },
                                    onChange: e => {
                                        setValue('contact', '')
                                        setInputDisable(false)
                                        onApplyMask()
                                    }
                                })}
                            >
                                <option value=''>Selecione</option>
                                <option
                                    value='1'
                                    data-mask='999.999.999-99'
                                    data-validate='validateCPF'
                                >CPF</option>
                                <option
                                    value='2'
                                    data-mask='99.999.999/9999-99'
                                    data-validate='validateCNPJ'
                                >CNPJ</option>
                                <option
                                    value='3'
                                    data-mask='99999-999'
                                    data-validate=''
                                >CEP</option>
                                <option
                                    value='4'
                                    data-mask='99/99/9999'
                                    data-validate='validateDate'
                                >DATA</option>
                                <option
                                    value='5'
                                    data-mask='(99) 99999-9999'
                                    data-validate=''
                                >CELULAR</option>
                            </Form.Select>
                            {errors.type_contact && <p className='mt-1 form-error'>{errors.type_contact.message}</p>}
                        </Form.Group>
                    </Col>

                    <Col lg={4}>
                        <Form.Group>
                            <Form.Label htmlFor='contact'>Contato</Form.Label>
                            <Controller
                                control={control}
                                defaultValue=''
                                {...register('contact', {
                                    required: { value: true, message: 'Campo obrigatório' },
                                    valueAsNumber: true,
                                    validate: inputValidate ? value => libValidate[inputValidate](value) : false
                                })}
                                render={({ field }) => (
                                    <MaskedInput
                                        mask={inputMask}
                                        maskChar=''
                                        value={field.value}
                                        onChange={field.onChange}
                                        disabled={inputDisable}
                                    >
                                        {(inputProps) => (
                                            <input
                                                {...inputProps}
                                                type='text'
                                                id='contact'
                                                className='form-control'
                                                disabled={inputDisable}
                                            />
                                        )}
                                    </MaskedInput>
                                )}
                            />
                            {errors.contact && <p className='mt-1 form-error'>{errors.contact.message}</p>}
                        </Form.Group>
                    </Col>
                </Row>

                <hr />

                <Row className='mb-3'>
                    <Col lg={6}>
                        <button
                            className='btn btn-danger float-start'
                            onClick={(e) => props.callbackParentModal((prevState) => ({ ...prevState, show: false }))}
                            type='button'
                        >
                            <FontAwesomeIcon icon={faTimes} className='me-2' /> Cancelar
                        </button>
                    </Col>

                    <Col lg={6}>
                        <button
                            className='btn btn-primary float-end'
                            type='submit'
                        >
                            <FontAwesomeIcon icon={faSave} className='me-2' /> Gravar
                        </button>
                    </Col>
                </Row>

            </Form>

        </>

    )
}

export default Contact;




